import styled from 'styled-components';
import { colors } from '../../../stylesheets';

const ProgressBar = styled.div`
  width: ${props => props.value}%;
  position: absolute;
  background-color: ${colors.green};
  top: 0;
  bottom: 0;
  left: 0;
  transition: all 0.3s;
  opacity: 0.5;
`;

export default ProgressBar;
